import { useState, useContext } from "react";
import "../Style/Header.css"
import { ReactComponent as SortIconSvg } from "../SVG/sort-icon.svg"
import { ReactComponent as SortUpIconSvg } from "../SVG/sort-up-icon.svg"
import { ReactComponent as SortDownIconSvg } from "../SVG/sort-down-icon.svg"
import TrainloadContext from "../Store/trainload-context";
import Sorter from "../Utility/Sorter"

const HeaderCell = (props) => {

    const [sortStatus, setSortStatus] = useState(0); // -1, 0, 1

    const trainloadCtx = useContext(TrainloadContext);

    const AddFunctionToFunnel = (fn, name) => {
        trainloadCtx.modifyFunnel(fn, name);
    }

    const handleToggleSort = () => {
        console.log("Toggled Sort Status");
        if (sortStatus === 0) {
            setSortStatus(prev => prev += 1);

            const fn = Sorter(props.data, "asc");
            AddFunctionToFunnel(fn, props.data);
        } else if (sortStatus === 1) {
            setSortStatus(prev => prev -= 2);

            const fn = Sorter(props.data, "desc");
            AddFunctionToFunnel(fn, props.data);
        } else {
            setSortStatus(prev => prev += 1); // turn into 0
            const fn = (x)=>x;
            AddFunctionToFunnel(fn, props.data);
        }
    }

    const determineIcon = (status) => {
        switch (status) {
            case 0:
                return (<SortIconSvg></SortIconSvg>);
            case 1:
                return (<SortUpIconSvg></SortUpIconSvg>);
            case -1:
                return (<SortDownIconSvg></SortDownIconSvg>);
            default:
                return (<></>)
        }

    }

    return props.isSortable ? (
        <div className="header-cell sortable" onClick={handleToggleSort}>
            {
                props.data
            }

            {determineIcon(sortStatus)}
        </div>
    ) :
        (
            <div className="header-cell">
                {
                    props.data
                }
            </div>
        );


}

export default HeaderCell;